var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('artisio-modal',{attrs:{"size":"xl","visible":_vm.modal.show,"title":_vm.$t("DPV Details"),"hide-footer":true,"scrollable":""},on:{"hidden":_vm.hideModal}},[_c('DpvLotsTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }